module.exports = __webpack_public_path__ + "static/media/allfunds-connect.6669d188.png";